import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'lib/axios';

export const useUser = (id: string): UseQueryResult<any[]> => {
	return useQuery({
		queryKey: ['user', id],
		queryFn: async() => {
			const { data: { user } } = await axios.get(`/users/${id}`);
      return user;
		}
	});
};